/*
 *
 *  *
 *  *  Copyright (C) THL A29 Limited, a Tencent company. All rights reserved.
 *  *  SPDX-License-Identifier: Apache-2.0
 *  *
 *
 */
import React, { useEffect } from 'react';
//导入路由组件
import Home from '../../routes/main/Home';
import Block from '../../routes/main/Block';
import { LoginModal } from '../../routes/main/User/LoginModal';//登录弹窗组件
import { FileValidation } from '../../routes/main/fileValidation';
import {Forensics} from "@src/routes/main/Forensics";
import {Header} from "@src/components/Header";
import {Footer} from "@src/components/Footer";
import style from './index.module.scss';
import { Routes, Route, Navigate, useNavigate, useParams,useLocation  } from 'react-router-dom';
//导入react-redux
import { useSelector } from "react-redux";

//导入路由守卫
import RouterGuard from './RouterGuard';

//创建一个context
interface ContextData {
  loginVisible: boolean;
  setLoginVisible: (visible: boolean) => void;
  loginPath: string;
  setLoginPath: (path: string) => void;
}
export const MyContext = React.createContext<ContextData>({
  loginVisible: false,
  setLoginVisible: () => {},
  loginPath: 'home',
  setLoginPath: () => {},
});

export default function Main() {
  const prePath = 'explorer';
  const navigate = useNavigate();
  //登录状态
  const isLogin = useSelector((state: any) => state.user.userInfo.token);

  //点击tab栏跳转到对应的页面的方法
  const [tabName, setTabName] = React.useState(window.location.pathname.split('/')[2] || 'home');
  let location = useLocation();
  //监听路由变化，改变tabName
  useEffect(() => {
    setTabName(location.pathname.split('/')[2] || 'home');
  }, [location.pathname]);

  const tabClick = (path: string) => {
    //如果没有登录，则forensics和fileValidation不可点击
    if (!isLogin && (path === 'forensics' || path === 'fileValidation')) {
      //登录弹窗
      setLoginVisible(true);
      //登录后要跳转的页面
      setLoginPath(path);
    } else {
      navigate(`/${prePath}/${path}`);
      setTabName(path);
    }    
  };

  //登录弹窗
  const [loginVisible, setLoginVisible] = React.useState(false);
  //登录后要跳转的页面
  const [loginPath, setLoginPath] = React.useState('home');
  //一个对象，用来存储登录和登录后要跳转的页面
  const loginObject = {
    loginVisible,
    setLoginVisible,
    loginPath,
    setLoginPath,
  };

  return (
    <div>
      <Header  tabName={tabName} tabClick={tabClick} setLoginVisible={setLoginVisible} />
      <Routes>
          <Route path="home" element={<MyContext.Provider value={loginObject}><Home /></MyContext.Provider>} />
          <Route path="block" element={<Block />} />
          <Route path="forensics" element={RouterGuard(<Forensics />)} />
          <Route path="fileValidation" element={RouterGuard(<FileValidation />)} />
          <Route path="*" element={<Navigate to="home" />} />
        </Routes>
      <Footer />
      <LoginModal loginModalVisible={loginVisible} setLoginModalVisible={setLoginVisible} loginPath={loginPath}/>
    </div>
  );
}
